import React, {useContext, useMemo, type ComponentType} from 'react';
import type {IStyles} from '@wix/tpa-settings';
import {useStyles} from '@wix/tpa-settings/react';
import {getShouldRenderVars} from '../../components/ProductPage/customCssVars/shouldRenderVars';
import {useEnvironment} from '@wix/yoshi-flow-editor';

interface AllStylesContext {
  styleParamsForAllBreakpoints: IStyles[];
  shouldRenderVarsForAllBreakpoints: Record<string, boolean>[];
}

const AllStylesContext = React.createContext<AllStylesContext>({} as AllStylesContext);

export function withAllStyles(Component: ComponentType) {
  return (props: any) => {
    const styles = useStyles();
    const {isRTL, isMobile} = useEnvironment();
    const styleParamsForAllBreakpoints = useMemo(() => styles.getStylesForAllBreakpoints(), [styles]);
    const shouldRenderVarsForAllBreakpoints = useMemo(
      () =>
        styleParamsForAllBreakpoints.map((stylesParamsPerBreakpoint) =>
          /* istanbul ignore next */
          getShouldRenderVars({
            booleans: stylesParamsPerBreakpoint.booleans,
            numbers: stylesParamsPerBreakpoint.numbers,
            // tpa-settings have a bug and sometimes separate fonts and string and sometimes dont
            // having everything inside strings is the more consistent behavior of theirs in the custom css vars flow
            strings: {...stylesParamsPerBreakpoint.strings, ...stylesParamsPerBreakpoint.fonts},
            isMobile,
            isRTL,
          })
        ),
      [styleParamsForAllBreakpoints, isMobile, isRTL]
    );

    return (
      <AllStylesContext.Provider
        value={{
          styleParamsForAllBreakpoints,
          shouldRenderVarsForAllBreakpoints,
        }}>
        <Component {...props} />
      </AllStylesContext.Provider>
    );
  };
}

export function useAllStyles() {
  return useContext(AllStylesContext);
}
